(function () {
  'use strict';

  var COOKIE = 'bb_adult';
  var LS_KEY = 'bb-adult-verified';
  var MAX_AGE = 60 * 60 * 24 * 30; // 30d

  function isVerified() {
    if (document.cookie.indexOf(COOKIE + '=1') !== -1) return true;
    try { return localStorage.getItem(LS_KEY) === '1'; } catch (e) { return false; }
  }

  function setVerified() {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE + '=1; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax' + secure;
    try { localStorage.setItem(LS_KEY, '1'); } catch (e) {}
    document.documentElement.setAttribute('data-adult-verified', 'true');
    document.documentElement.setAttribute('data-theme', 'midnight');
  }

  function clearVerified() {
    document.cookie = COOKIE + '=; Max-Age=0; Path=/; SameSite=Lax';
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
    document.documentElement.removeAttribute('data-adult-verified');
    document.documentElement.setAttribute('data-theme', 'mocha');
  }

  var pendingHref = null;
  var focusReturnEl = null;

  function openModal(href) {
    var modal = document.getElementById('adult-gate-modal');
    if (!modal) return false;
    focusReturnEl = document.activeElement;
    pendingHref = href || null;
    var form = modal.querySelector('[data-adult-gate-form]');
    if (form) form.reset();
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    var confirm = modal.querySelector('[data-adult-gate-confirm]');
    if (confirm) setTimeout(function () { confirm.focus(); }, 0);
    return true;
  }

  function closeModal() {
    var modal = document.getElementById('adult-gate-modal');
    if (!modal) return;
    if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
    if (focusReturnEl && typeof focusReturnEl.focus === 'function') {
      focusReturnEl.focus();
      focusReturnEl = null;
    }
  }

  function onSubmit(e) {
    var modal = document.getElementById('adult-gate-modal');
    if (!modal) return;
    var confirm = modal.querySelector('[data-adult-gate-confirm]');
    if (!confirm || !confirm.checked) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    setVerified();
    closeModal();
    var returnUrl = getReturnParam();
    if (returnUrl) {
      location.assign(returnUrl);
      return;
    }
    if (pendingHref) {
      var href = pendingHref;
      pendingHref = null;
      location.assign(href);
      return;
    }
    // Same-page reveal: dispatch event so listeners (e.g. lazy-loaded cards) can react.
    document.dispatchEvent(new CustomEvent('adult:verified'));
  }

  function getReturnParam() {
    try {
      var params = new URLSearchParams(location.search);
      var r = params.get('return');
      if (!r) return null;
      // Allow only same-origin paths.
      if (r.charAt(0) === '/' && r.charAt(1) !== '/') return r;
    } catch (e) {}
    return null;
  }

  function isAdultPath() {
    return location.pathname === '/pages/adult' || location.pathname === '/pages/adult/';
  }

  function interceptLinks() {
    document.addEventListener('click', function (e) {
      var adultLink = e.target.closest('a[data-adult-link]');
      if (adultLink) {
        if (!isVerified()) {
          e.preventDefault();
          openModal(adultLink.getAttribute('href'));
        }
        return;
      }
      var trigger = e.target.closest('[data-adult-trigger]');
      if (trigger) {
        e.preventDefault();
        if (!isVerified()) openModal(null);
        return;
      }
      var exit = e.target.closest('[data-adult-exit]');
      if (exit) {
        e.preventDefault();
        clearVerified();
        location.reload();
      }
    });
  }

  function wireModal() {
    var modal = document.getElementById('adult-gate-modal');
    if (!modal) return;
    var form = modal.querySelector('[data-adult-gate-form]');
    var cancel = modal.querySelector('[data-adult-gate-cancel]');
    if (form) form.addEventListener('submit', onSubmit);
    if (cancel) cancel.addEventListener('click', function () {
      pendingHref = null;
      closeModal();
      if (isAdultPath()) {
        location.assign('/');
      }
    });
    modal.addEventListener('cancel', function (ev) {
      pendingHref = null;
      if (isAdultPath()) {
        ev.preventDefault();
        location.replace('/');
      }
    });
  }

  function checkPdpGate() {
    if (isVerified()) return;
    if (document.body && document.body.getAttribute('data-product-adult') === 'true') {
      location.replace('/pages/adult?return=' + encodeURIComponent(location.pathname + location.search));
    }
  }

  function checkAdultPage() {
    if (!isAdultPath()) return;
    if (isVerified()) {
      var r = getReturnParam();
      if (r) location.replace(r);
      return;
    }
    openModal(null);
  }

  function init() {
    wireModal();
    interceptLinks();
    checkPdpGate();
    checkAdultPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
